import { Schema as S } from "effect";

import { apiData } from "../../api/asyncData";
import { AgentsData } from "../../api/schemas/agents";
import { Dialog } from "../../widgets/dialog";
import * as Picker from "../../widgets/recordPicker";

/** Every write the page makes; promote and both revokes go through the confirm dialog first. */
export const WriteKind = S.Literals([
	"promote",
	"revoke",
	"revokeLink",
	"deny",
]);
export type WriteKind = typeof WriteKind.Type;

/** A write awaiting the owner's confirmation: a context (`id` = contextId) or a link. */
export const PendingWrite = S.Struct({
	kind: S.Literals(["promote", "revoke", "revokeLink"]),
	id: S.String,
	title: S.String,
});
export type PendingWrite = typeof PendingWrite.Type;

/** "Connect an agent": creating its API key, and the key, shown once. */
export const Connect = S.Struct({
	name: S.String,
	creating: S.Boolean,
	created: S.Option(S.Struct({ name: S.String, key: S.String })),
	error: S.Option(S.String),
	copied: S.Boolean,
});
export type Connect = typeof Connect.Type;

/** "Share an agent": a named link for one person, and its URL, shown once. */
export const Share = S.Struct({
	/** "" until the owner picks; the view falls back to the first agent. */
	agentId: S.String,
	label: S.String,
	picker: Picker.Model,
	creating: S.Boolean,
	created: S.Option(S.Struct({ label: S.String, url: S.String })),
	error: S.Option(S.String),
	copied: S.Boolean,
});
export type Share = typeof Share.Type;

/** What happened to the last approved send: delivered, or why not. */
export const SendOutcome = S.Struct({
	to: S.String,
	error: S.Option(S.String),
});
export type SendOutcome = typeof SendOutcome.Type;

/** "Add someone's agent": a person record and the link they gave you. */
export const Paste = S.Struct({
	picker: Picker.Model,
	url: S.String,
	saving: S.Boolean,
	error: S.Option(S.String),
	/** The person whose link was just saved, for a one-line confirmation. */
	saved: S.Option(S.String),
});
export type Paste = typeof Paste.Type;

export const Model = S.Struct({
	page: S.Literal("Agents"),
	/** Live, not time-versioned (KTD8): no asOf tag, generation guards staleness. */
	data: apiData(AgentsData).schema,
	/** A failed promote or revoke; cleared by the next action. */
	error: S.Option(S.String),
	dialog: Dialog.Model,
	pending: S.Option(PendingWrite),
	/** A confirmed write is in flight. */
	writing: S.Boolean,
	connect: Connect,
	share: Share,
	sendOutcome: S.Option(SendOutcome),
	paste: Paste,
});
export type Model = typeof Model.Type;
